<template>
  <div class="page-content"  id="monitoringLink">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/newLinkList' }">监控链接</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form label-width="130px">
        <el-form-item label="监控模式：" :required="true">
          <el-radio v-model="radio" label="0">标价</el-radio>
          <el-radio v-model="radio" label="1">到手价</el-radio>
        </el-form-item>
        <el-form-item label="监控链接：" :required="true">
          <div class="addFont" @click="newAdd">
            <i class="el-icon-plus"></i>
            新增监控链接
          </div>
        </el-form-item>
      </el-form>

      <el-button size="small" style="margin-left: 47px;margin-bottom: 8px;" @click="delSure('批量删除')">
        批量删除
      </el-button>
      <span style="padding-left: 15px;color: #FAAD14;">
        可监控链接数量上限：{{totalNum}}/{{allLimitProNum}}
      </span>
      <el-table
        @selection-change="handleSelectionChange"
        :data="productsData"
        ref="multipleTable"
        style="padding-left: 47px;padding-bottom: 10px;"
        height="460"
        >
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column label="商品信息" prop="platformchild">
          <template slot-scope="scope">
            <div class="shopMain">
							<img :src="scope.row.picurl" alt/>
							<div class="content">
								{{scope.row.itemtitle}}
                <el-link class="align_left" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
									{{scope.row.itemlink}}
								</el-link>
							</div>
						</div>
          </template>
        </el-table-column>
        <el-table-column label="SKU信息" prop="shopnamechild">
          <template slot-scope="scope">
            <div class="shopMain" v-for="(item,index) in scope.row.skuList">
							<img :src="item.skuPhoto" v-if="item.skuPhoto.indexOf('None') === -1" alt/>
							<div class="content">
								<el-link class="align_left" :underline="false" :href="item.itemlink" type="primary" target="_blank">
									{{item.skuTitle}}
								</el-link>
							</div>
              <!-- <el-button type="text" v-if="item.deleteFlag == 1" @click="closeDeleteShow(scope.$index,index,item,0)">监控</el-button>
              <el-button type="text" v-if="item.deleteFlag == 0" @click="closeDeleteShow(scope.$index,index,item,1)">取消监控</el-button> -->
						</div>
          </template>
        </el-table-column>

        <el-table-column label="限价" prop="shopnamechild" :required="true">
          <template slot-scope="scope">
            <smallTable :smallData="scope.row.skuList" :smallIndex="scope.$index" @tableClick="taplePrice" ref="childTable"></smallTable>
          </template>
        </el-table-column>
        <el-table-column width="210" label="操作">
          <template slot-scope="scope">
            <div class="g-margin-left" style="color: #108cee;cursor: pointer;">
              <i class="el-icon-delete"></i>
              <span class="g-inline-block" @click="delSure(scope.$index)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <shopLink ref="childShopLink" @fromChild="getChild"></shopLink>
      <el-form label-width="130px" style="margin-top: 24px;">
        <el-form-item label="通知人：">
          <el-select v-model="openid" multiple placeholder="请选择" size="small" style="width: 425px;">
            <el-option
              v-for="item in WecharList"
              :key="item.openid"
              :label="item.nickname"
              :value="item.openid">
            </el-option>
          </el-select>
          <el-button type="text" size="small" style="margin-left: 8px;" @click="getbmcwx">新增通知人</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-left: 51px;margin-top: 40px;">
        <el-button size="small" class="g-confirm-btn" @click="save" type="primary" :loading="saveLoading">确 认</el-button>
  			<el-button size="small" @click="$router.push(`/newLinkList`)" type="TheCustom">取 消</el-button>
      </div>
    </section>
  </div>
  <wxBindingComponent ref="childWxBinding"/>
</div>

</template>

<script>
  import shopLink from "./shopLink.vue";
  import smallTable from "./smallTable.vue";
  import wxBindingComponent from "../../../../components/wxComponent/wxBindingComponent.vue";
  import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        // deleteShow: false,
        rowindex: '',
        DeleteIndex: '',
        DeleteItem: '',
        deleType: '',
        shopPrice: false,
        fillPrice: "",
        skuPricesInput: [],
        radio: '1',
        storeAlinkShow: false,
        storePlatform: '',
        status: 0,
        title: '新增',
        bid: '',
        wechatUrl: '',
        saveLoading: false,
        multipleSelection:[],
        shopmonitorPlatform:[],
        time:[],
        platformList: [
  				{ value: 'PDD', label: '拼多多' },
  				{ value: 'TB', label: '淘宝' },
  				{ value: 'TM', label: '天猫' },
  				{ value: 'JD', label: '京东' },
          { value: 'SN', label: '苏宁' },
  				{ value: '1688', label: '1688' },
  			],
        openid: [],
        planname: '',
        plathour: [],
        platform: [],
        limitTotle: 0,
        allLimitProNum: 0,
        productsData: [],
        WecharList: [],
        faData: [],
        faPriceData: [],
        batchindex: '',
        skuLength: '',
        noticeids: [],
        skuListids: [],
        pricesardData: [],
        totalNum: 0,
        itemids: [],
      }
    },
    mounted() {
      // 获取监控时间监控个数
      fetch({
  			url: 'hcm/cus/selectbmcSetting'
  		}).then(res => {
  			if(res.status === '10000') {
          this.allLimitProNum = res.data.singlelinkNumber;
          if (res.data.singlelinkPlatform) {
            let platArr = []
            platArr = res.data.singlelinkPlatform.split(',')
            console.log('可监控平台',platArr)
            for (let a in platArr) {
              if (platArr[a] == 'TB') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '淘宝'
                })
              } else if (platArr[a] == 'TM') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '天猫'
                })
              } else if (platArr[a] == 'JD') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '京东'
                })
              } else if (platArr[a] == 'SN') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '苏宁'
                })
              } else if (platArr[a] == 'PDD') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '拼多多'
                })
              } else if (platArr[a] == '1688') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '1688'
                })
              } else if (platArr[a] == 'DD') {
                this.shopmonitorPlatform.push({
                  value: platArr[a],
                  label: '当当'
                })
              }
            }
          }
  			}
  		})
      this.totalNum = Number(this.$route.query.totalNum)
      // 获取监控时间
      this.getWecharList();
    },
    methods: {

      // 设置限价
      taplePrice(data) {
        this.faPriceData[data.index] = data.skuPricesInput
        this.pricesardData = this.faPriceData
      },
      // 获取bid调用微信接口
      getbmcwx() {
        fetch({
          url: "hcm/userout/getbmcwx",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.bid = data.data.bid
            this.addWechatPerson()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      addWechatPerson() {
        this.$refs.childWxBinding.getbmcwx('m',this.bid)
  		},
      // 监控时间总数
      limitFun() {
        this.limitTotle = this.plathour.length
      },
      // 新增监控产品
      newAdd() {
        let data = {
          radio: this.radio,
          totalNum: this.totalNum,
          allLimitProNum: this.allLimitProNum,
          shopmonitorPlatform: this.shopmonitorPlatform
        }
        this.$refs.childShopLink.faOpen(data)
      },
      // 获取微信通知人数据
      getWecharList() {
        fetch({
          url: "hcm/hcmNewMonitorProduct/getWecharList",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.WecharList = res.data
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 子传父
      getChild(data) {
        console.log(data)
        // 新增监控产品表格数据
        console.log('新增监控链接表格数据')
        for (let a in data.data) {
          this.productsData.push(data.data[a])
        }
        this.noticeids.push(data.noticeids)
        this.totalNum = this.totalNum + this.productsData.length
      },
      // 链接删除
      delSure(index) {
        if (index == '批量删除') {
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择产品信息',
              type: "error"
            });
            return;
          }
          for (let a in this.multipleSelection) {
            for (let b in this.productsData) {
              if (this.multipleSelection[a] === this.productsData[b]) {
                this.itemids.push(this.productsData[b].itemid)
                this.productsData.splice(b,1)
              }
            }
          }
        } else {
          this.itemids.push(this.productsData[index].itemid)
          this.productsData.splice(index,1)
        }
        this.totalNum = this.totalNum + this.productsData.length

        let params={
          itemids: this.itemids.join(','),
        }
        fetch({
          url: "hcm/monitorLink/deleteNewMonitorList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '成功',
              type: 'success'
            });

          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      save() {
        if (this.productsData.length == 0) {
          this.$message({
            message: '请添加监控链接',
            type: 'warning'
          });
          return
        }
        if (this.totalNum > this.allLimitProNum) {
          this.$message({
            message: '超出监控链接数量上限',
            type: 'warning'
          });
          return
        }
        this.saveLoading = true
        if (this.openid.length > 0) {
          this.setPushNoticePeople()
        }
        this.priceStandard()
      },
      // 确认设置限价
      priceStandard() {
        // 判断是否所有限价都填了
        let skuQuantity = []
        this.skuListids = []
        if (this.productsData.length > 0) {
          for (let a in this.productsData) {
            for (let b in this.productsData[a].skuList) {
              // if (this.productsData[a].skuList[b].deleType != 1) {
                skuQuantity.push(this.productsData[a].skuList[b])
                this.skuListids.push(this.productsData[a].skuList[b].id)
              // }
            }
          }
        }
        let arrprices = []
        for (let h in this.pricesardData) {
          for (let k in this.pricesardData[h]) {
            arrprices.push(this.pricesardData[h][k])
          }
        }
        for (let i in this.pricesardData) {
          if (this.pricesardData[i] == '') {
            this.$message({
              message: '请填写限价',
              type: 'warning'
            });
            this.saveLoading = false
            return
          }
        }
        if (skuQuantity.length != arrprices.length) {
          this.$message({
            message: '请填写限价',
            type: 'warning'
          });
          this.saveLoading = false
          return
        }
        let params={
          prices: arrprices.join(','),
          ids: this.skuListids.join(','),
        }
        fetch({
          url: "hcm/monitorLink/priceStandard",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.productsData = []
            this.openid = []
            this.saveLoading = false
            this.$router.push(`/newLinkList`)
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 设置通知人
      setPushNoticePeople() {
        let params={
          ids: this.noticeids.join(','),
          openids: this.openid.join(','),
        }
        fetch({
          url: "hcm/monitorLink/setPushNoticePeople",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){

          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
    },
    components: {
      shopLink,smallTable,wxBindingComponent
    }
  }
</script>
<style lang="scss">
  #monitoringLink{
    .shopMain {
    	display: flex;
    	justify-content: flex-start;
    	align-items: center;
    	margin-bottom: 5px;
    	.content {
    		width: calc(100% - 58px);
    	}
    	img {
    		width: 48px;
    		height: 48px;
    		margin-right: 5px;
    		display: block;
    	}
    }
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .addFont {
      color: #108cee;
      font-weight: bold;
      text-align: center;
      border: 1px dashed #e8ebec;
      height: 30px;
      width: 425px;
      line-height: 30px;
      cursor: pointer;
    }
    .addFont:hover {
      border: 1px dashed #108cee;
    }
  }
</style>
